import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DatePipe} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {NotificationService} from 'src/app/core/services/notification.service';
import {ToastrService} from 'ngx-toastr';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {Message} from 'src/app/core/class/message';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {DocumentService} from 'src/app/core/services/document.service';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {SignProgressComponent} from './sign-progress/sign-progress.component';
import {BehaviorSubject, Subscription} from 'rxjs';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {CommonService} from 'src/app/core/services/common.service';
import {ConfirmSignOtpComponent} from '../confirm-sign-otp/confirm-sign-otp.component';
import {ApiService} from 'src/app/core/services/api.service';
import {AlertComponent} from 'src/app/shared/components/alert/alert.component';
import {ContractService} from 'src/app/core/services/contract.service';
import {EnumSignMethod} from "../../../../../../core/constants/contract";
import {
  imageConfigFormPreviewId,
  imageConfigRenderId,
  imageConfigViewScaleId,
  ImageSignConfigComponent,
  transformContentPositionValue
} from '../sign-flow-document/image-sign-config/image-sign-config.component';
import {ContentPosition, SignatureConfig} from '../sign-flow-document/signature-config.model';
// import { readUint16 } from 'src/assets/js/pdf.worker';
import {catchError, delay, map, switchMap, tap} from 'rxjs/operators';
import * as htmlToImage from 'html-to-image';
import {ImageGenerateService} from "../../../../../../core/services/image-generate.service";
import { CanvasService } from 'src/app/core/services/canvas.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CanvasComponent } from 'src/app/shared/components/canvas/canvas.component';
// @ts-ignore
import { NzUploadFile } from "ng-zorro-antd/upload";
import { DomSanitizer } from '@angular/platform-browser';

declare function signHash(comp, hashBase64): any;

declare function initPlugin(comp): any;

declare function initPluginCertificateNormal(comp, contracts: any): any;

@Component({
  selector: 'app-sign-document',
  templateUrl: './sign-document.component.html',
  styleUrls: ['./sign-document.component.scss']
})
export class SignDocumentComponent implements OnInit, OnDestroy, AfterViewInit {
  // @ts-ignore
  @ViewChild('SignImageConfig2', {static: true}) domRenderImage: ElementRef
  /**
   * stop sign action.
   */
  public static CONFIRM_ACTION = 'confirm';
  signConfig: SignatureConfig = SignatureConfig.build();
  public static CONFIRM_ACTION_NON_CERTIFICATE = 'confirm2';
  scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * sign slot of document.
   */
  public static SIGN_SLOT = 'slot';

  public static DLECINE_SLOT = 'decline slot';
  /**
   * sign single of document.
   */
  public static SIGN_SINGLE = 'single';

  /**
   * sign with server.
   */
  public static SIGN_SERVER = 0;

  /**
   * sign with usb token.
   */
  public static SIGN_USB_TOKEN = 1;

  /**
   * Sign with sim ca.
   */
  public static SIGN_SIM_CA = 2;

  /**
   * Sign with hsm.
   */
  public static SIGN_OTP = 3;

  /**
   * Sign with hsm.
   */
  public static SIGN_HSM = 4;

  public static DOCUMENT_UPLOAD = 1;

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  public signMultiType = new BehaviorSubject<number>(null);

  /**
   * sign type.
   */
  signType: string;

  /**
   * data single sign.
   */
  dataSignSingle: any;

  /**
   * data sign slot.
   */
  dataSignSlot: any;

  /**
   * Certificate Id
   */
  certificate: any;

  /**
   * selected cert.
   */
  selectedCert: any;

  /**
   * dialog signed.
   */
  dialogSign: any;

  /**
   * Model certificate
   */
  certificates: any;

  /**
   * Type certificate
   */
  typeCertificate: number;

  /**
   * Model request create hash
   */
  sign = {
    contractId: '',
    digitalCertificateId: '',
    digitalCertificateDetailId: '',
    certificate: '',
    path: '',
    signature: '',
    signPdf: '',
    phoneNumber: '',
    serialNumber: '',
    image: null
  };
  SignatureConfig = SignatureConfig.build();

  enterpriseByService = {
    warningSmsTotalMoney: false,
  };

  /**
   * variable check form change
   */
  isFormChanging = false;

  checkFocus = true;
  show = true;

  /**
   * Check submit succee
   */
  success = false;

  isHsmPermission: boolean = false

  /**
   * Get enterpriseId
   */
  enterpriseId = localStorage.getItem('enterpriseId');
  cloudCaMultiSignThreshold = localStorage.getItem('cloudCaMultiSignThreshold');
  cloudCaSessionMultiSignThreshold = localStorage.getItem('cloudCaMultiSignThreshold');
  usbTokenMultiSignThreshold = localStorage.getItem('usbTokenMultiSignThreshold');

  linkDownSignPlugin = (os ?: string) => {
    let OSName = "Unknown OS";
    if (navigator.appVersion.indexOf("Win") != -1) OSName = "WINDOWS";
    if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MACOS";
    if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
    if (navigator.appVersion.indexOf("Linux") != -1) OSName = "LINUX";


    return this.apiService.getBaseUrl() + `/file/download-last-version?os=${OSName}&typeFile=${OSName === "WINDOWS" ? 'exe' : OSName === "LINUX" ? 'deb' : 'pkg'}`;
  };

  columnsToDisplay = ['issuedTo', 'taxCode', 'phoneNumber', 'expireDate'];
  columnsToDisplayCA = ['issuedTo', 'taxCode', 'phoneNumber', 'expireDate', 'hasTransSaved'];
  /**
   *
   */
  @BlockUI() blockUI: NgBlockUI;
  userType: any;
  signTypes = EnumSignMethod;
  enumSignMethod = EnumSignMethod;
  public isShareMysignEnable: boolean;
  // @ts-ignore
  @ViewChild(ImageSignConfigComponent) imageSignConfig: ImageSignConfigComponent;
  // @ts-ignore
  // @ViewChild("SignImageConfig", { static: true }) domRenderImage: ElementRef;
  // @ts-ignore
  @ViewChild(CanvasComponent) canvasComponent;
  @Input() public canvasWidth = 660;
  @Input() public canvasHeight = 300;
  public subscribeMediaBreakPointService: Subscription;
  public mediaBreakpoint: any;
  public indexSelect: number = 0;
  private isSelectDrawImage = false;
  public imageUrlPreview: any;
  isRenderImage = true;
  systemImageSign = false;
  selectedImage: File;
  signatureImageDefault: string = "";
  signatureFileDefault: any;
  signatureImageUpload: string = "";
  signatureImageDraw: string = "";
  // ảnh vẽ đã lưu trong Phương thức ký (defaultSignImageType=2) -> bind vào app-canvas để khôi phục nét vẽ
  drawRestoreImage: string = null;
  loading: boolean;
  public avatarUrl: string;

  // Fix race condition: tách biệt fileUpload theo từng tab
  activeImageSource: 'default' | 'upload' | 'draw' = 'default';
  fileUploadDefault: File;   // Tab 0: Ảnh mặc định hệ thống
  fileUploadUpload: File;    // Tab 1: Ảnh tải lên
  fileUploadDraw: File;      // Tab 2: Vẽ chữ ký
  // fileUpload: dùng cho UI (preview, disable button) - giữ nguyên
  fileUpload: File;
  widthImageRender: number = 0;
  heightImageRender: number = 0;
  widthRectangle: number = 300; // width khung ký
  heightRectangle: number = 136; // height khung ký
  imagePreviewWidth: number = 0;
  imagePreviewHeight: number = 0;
  beforeUpload = this.commonService.beforeUploadImage;
  enterpriseName: string = "";
  public signMethod = {
    SIGN_SERVER: 0,
    SIGN_USB_TOKEN: 1,
    SIGN_SIM_CA: 2,
    SIGN_OTP: 3,
    // SIGN_HSM: 4,
    // SIGN_IMAGE: 5,
    SIGN_NO_CERT: 6,
    SIGN_EKYC: 7,
    SIGN_EKYC_ADVANCED: 8,
    CLOUD_CA: 10
  };

  constructor(
    private cd: ChangeDetectorRef,
    private contractService: ContractService,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    private commonService: CommonService,
    private apiService: ApiService,
    private digitalCertificateService: DigitalCertificateService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<SignDocumentComponent>,
    private signDocumentService: SignDocumentService,
    private imageGenerateService: ImageGenerateService,
    private canvasService: CanvasService,
    private responsiveService: ResponsiveService,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: {
      type: string,
      document: any,
      documentTypeId?: number,
      documentEnterpriseId: string,
      documentEntity: any,
    }
  ) {
    if (data.type === SignDocumentComponent.SIGN_SLOT) {
      this.dataSignSlot = data.document;
    } else {
      this.dataSignSingle = data.document;
    }

    this.signType = data.type;

    dialogRef.disableClose = false;
    this.userType = localStorage.getItem('userType');
    this.enterpriseName = localStorage.getItem("fullName");
  }

  /**
   * Init compon
   */
  async ngOnInit() {
    this.scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
    this.notificationService.subscribeErrorService();
    this.getCertificates();
    await this.getUserConfig().toPromise();

    this.isShareMysignEnable = localStorage.getItem('isShareMysignEnable') == 'true';
    this.documentService.getApparamInfo({code: 'cloud_ca_multi_session_sign.threshold'}).subscribe(res =>{
      if(res.data){
        this.cloudCaSessionMultiSignThreshold = res.data.value
      }
    })
    this.canvasService.canvasSignatureImage.subscribe((imgUpload) => {
      if (imgUpload) {
        this.fileUpload = imgUpload;
        this.fileUploadDraw = imgUpload;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.documentService.setImageSignature(null);
    this.canvasService.setCanvasSignatureImageUrl("");
    this.canvasService.setCanvasSignatureImage(null);
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.domRenderImage = null;
    this.fileUpload = null;
    this.fileUploadDefault = null;
    this.fileUploadUpload = null;
    this.fileUploadDraw = null;
    this.activeImageSource = 'default';
    this.systemImageSign = false;
    this.imageUrlPreview = null;
  }

  ngAfterViewInit(){
    this.subscribeMediaBreakPointService = this.responsiveService
      ._getMediaBreakpoint()
      .subscribe((media) => {
        if (media === "") {
          this.mediaBreakpoint = "";
          return;
        } else {
          this.mediaBreakpoint = media;
          switch (this.mediaBreakpoint) {
            case SCREEN_SIZE.XS:
              this.canvasWidth = 242;
              this.canvasHeight = Math.round(242 * (136 / 300));
              break;
            case SCREEN_SIZE.SM:
              this.canvasWidth = 242;
              this.canvasHeight = Math.round(242 * (136 / 300));
              break;
            case SCREEN_SIZE.MD:
              this.canvasWidth = 242 ;
              this.canvasHeight = Math.round(242 * (136 / 300));
              break;
            case SCREEN_SIZE.XL:
              this.canvasWidth = 470;
              break;
            default:
              this.canvasWidth = 660;
              break;
          }
        }
      });
  }

  getMessageCloudCaThreshold() {
    if(this.selectedCert && this.selectedCert.hasTransSaved){
      return this.message.getMessage('search_form.cloud_ca_multi_sign_threshold').replace('{0}', this.cloudCaSessionMultiSignThreshold);
    } else {
      return this.message.getMessage('search_form.cloud_ca_multi_sign_threshold').replace('{0}', this.cloudCaMultiSignThreshold);
    }
  }

  getMessageUsbTokenThreshold() {
    return this.message.getMessage('search_form.usb_token_multi_sign_threshold').replace('{0}', this.usbTokenMultiSignThreshold);
  }

  getMessageSelectCert() {
    let msg = this.message.getMessage('messages.please_select_mysign_or_usb_token');
    // debugger
    if (this.isShareMysignEnable) {
      // nếu bật chia lượt ký mysign và khách hàng cá nhân thì chỉ usb token thôi
      if(this.userType == "5"){
        msg = this.message.getMessage('messages.please_select_usb_token');
      }
    }
    return msg;
  }
  /**
   * Process sign document with signatures server
   */
  processSignServer() {
    if (!this.data.documentEntity.submitedToA && this.data.documentEntity.status === 0
      || (!this.data.documentEntity.submitedToB && (this.data.documentEntity.status === 4 || this.data.documentEntity.status === 8) && Number(this.userType) !== 5)) {
      this.signDocumentService.signatureServerDirectly(this.sign).subscribe(rs => {
        this.onSignSuccess();
      });
    } else {
      this.signDocumentService.signatureServer(this.sign).subscribe(rs => {
        this.onSignSuccess();
      });
    }
  }

  getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService() {
    this.contractService.getDataSmsContractQuantityByEnterpriseId(this.data.documentEnterpriseId).subscribe(
      response => {
        if (Object.keys(response.data).length !== 0 && response.data.constructor === Object) {
          this.enterpriseByService.warningSmsTotalMoney = response.data.warningSmsTotalMoney;
        }
      }
    );
  }

  /**
   * Process sign document with HSM
   */
  processSignHSM() {
    this.signDocumentService.signHSM(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  /**
   * Process sign document with Sim CA
   */
  processSignSimCA() {
    this.sign.phoneNumber = this.certificate.phoneNumber;
    this.sign.serialNumber = this.certificate.serialNumber;
    if (!this.data.documentEntity.submitedToA && this.data.documentEntity.status === 0
      || (!this.data.documentEntity.submitedToB && (this.data.documentEntity.status === 4 || this.data.documentEntity.status === 8) && Number(this.userType) !== 5)) {
      this.signDocumentService.signSimCADirectly(this.sign).subscribe(rs => {
        this.onSignSuccess();
      });
    } else {
      this.signDocumentService.signSimCA(this.sign).subscribe(rs => {
        this.onSignSuccess();
      });
    }
  }

  onChangeType() {
    this.selectedCert = null;
  }

  /**
   * Process after signing success
   */
  private onSignSuccess() {
    this.toastr.success(this.message.getMessage('messages.sign_success'));
    this.success = true;
    this.dialogRef.close();
  }

  /**
   * Compare Serianumber and create Hash
   */
  createHash(certUserBase64: string) {
    if (this.dataSignSingle !== null) {
      this.sign.certificate = certUserBase64;
      this.documentService.createHash(this.sign).subscribe(rs => {
        this.sign.path = rs.data.path;
        this.sign.signPdf = rs.data.signPdf;
        // fix sonar
        // this.sign.signature = signHash(this, rs.data.hash);
        if (this.sign.signature) {
          if (!this.data.documentEntity.submitedToA && this.data.documentEntity.status === 0
            // tslint:disable-next-line:max-line-length
            || (!this.data.documentEntity.submitedToB && (this.data.documentEntity.status === 4 || this.data.documentEntity.status === 8) && Number(this.userType) !== 5)) {
            this.signUsbDirectly(this.sign);
          } else {
            this.signUsb(this.sign);
          }
        }
      });
    }
  }

  /**
   * Sign Usb
   */
  signUsb(certificate: any) {
    this.documentService.signUsb(certificate).subscribe(() => {
      this.onSignSuccess();
    });
  }

  signUsbDirectly(certificate: any) {
    this.documentService.signUsbDirectly(certificate).subscribe(() => {
      this.onSignSuccess();
    });
  }

  /**
   * Click cancel.
   */
  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '30%',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Get list cerfiticate
   */
  getCertificates() {
    const isSignLot = this.signType === SignDocumentComponent.SIGN_SLOT;

    this.digitalCertificateService.getCertificates(this.enterpriseId, isSignLot).subscribe(rs => {
      let displayCerts = [];

      if (rs && rs.data) {
        if (isSignLot) {
          rs.data.forEach(cert => {
            let check = false;
            cert.listCert.forEach(item => {
              if (Number(item.typeCertificate) === EnumSignMethod.SIGN_SERVER
                || Number(item.typeCertificate) === EnumSignMethod.CLOUD_CA
                || Number(item.typeCertificate) === EnumSignMethod.SIGN_USB_TOKEN) {
                check = true;
              }
            });

            if (check) {
              displayCerts.push(cert);
            }
          });
        } else {
          // Check condition is document upload then not allow sign OTP
          // if (this.data.documentTypeId === SignDocumentComponent.DOCUMENT_UPLOAD) {
          //   rs.data.forEach(cert => {
          //     let check = false;
          //     cert.listCert.forEach(item => {
          //       if (Number(item.typeCertificate) !== SignDocumentComponent.SIGN_OTP) {
          //         check = true;
          //       }
          //     });
          //
          //     if (check) {
          //       displayCerts.push(cert);
          //     }
          //   });
          // } else {
          //   displayCerts = rs.data;
          // }

          // rs.data.forEach(x => {
          //   x.listCert.forEach(item => {
          //     if (item.phoneNumber !== '' && item.phoneNumber !== undefined) {
          //       item.phoneNumber = item.phoneNumber.replace("84", "0");
          //     }
          //     return item;
          //   });
          //
          //   return x;
          // })

          displayCerts = rs.data;
        }
      }

      this.certificates = displayCerts;
      if (this.certificates.length > 0) {
        for (const cerType of this.certificates) {
          cerType.listCert = cerType.listCert.map((item, index) => {
            const { imagePath } = item;
            if (imagePath) {
              const imageDataBlob = this.commonService.b64toBlob(imagePath);
              const blobUrl = URL.createObjectURL(imageDataBlob);
              return {
                ...item,
                imageUrl: blobUrl,
              };
            } else {
              return {
                ...item,
                imageUrl: "",
              };
            }
          });
        }
      }

      // Select first certificate
      this.typeCertificate = this.certificates[0].type;
      this.selectedCert = this.certificates[0].listCert[0];
      this.setIssueTo(this.selectedCert);
      this.setEmailTo(this.selectedCert);
      this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
        if (res && res.success) {
          this.isHsmPermission = res.data.enableHsm
        }
      })
      if (this.selectedCert.id) {
        this.typeCertificate = this.selectedCert.typeCertificate;
        this.signFlowDocumentWithCertificate();
      }
    });
  }

  /**
   * Show error form certificate.js
   * @param msg message
   */
  showErrMsg(msg) {
    this.toastr.error(msg);
  }

  /**
   * Show error form certificate.js
   * @param msg message
   */
  showErrMsgTransle(msg) {
    this.blockUI.stop();
    this.toastr.error(this.message.getMessage(msg));
  }

  createATag(link: string, title: string) {
    return '<a target="_blank" href="' + link + '">' + title + '</a>';
  }

  /**
   * Show error format form certificate.js
   * @param msg message
   */
  showErrMsgTransleFormat(msg) {
    this.blockUI.stop();
    const link = this.linkDownSignPlugin();
    console.log("here we go ", link);

    if (msg === "messages.not_initPlugin") {
      msg = "messages.initPlugin_faile"
    }

    this.dialog.open(AlertComponent, {
      width: '370px',
      data: this.message.getMessage(msg)
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>'
        // + '<br/ >' + this.message.getMessage('messages.download_plugin_sign_os') + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
        // + '<a target="_blank" href="' + link + '"> '+
        + this.createATag(this.linkDownSignPlugin('WINDOWS'), "Windows, ") + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
      // + '</a>'
      // + '<br/ >' + this.message.getMessage('messages.download_plugin_sign_os') +
    });
  }

  /**
   * Click on cancel button.
   */
  onClickCancelButton() {
    if (this.signType === SignDocumentComponent.SIGN_SINGLE) {
      this.onNoClick();
    } else {
      this.actions.next(SignDocumentComponent.CLOSE_ACTION);
    }
  }

  setSizeFrameImage() {
    switch (this.signConfig.signaturePosition.value) {
      case 'left':
      case 'right':
        return {
          width: '370px',
          height: '136px'
        };
      case 'top':
      case 'bottom':
        return {
          width: '300px',
          height: '237px'
        };

      default:
        return {
          width: '300px',
          height: '136px'
        };
    }
  }

  async onClickConfirmButton() {
    // getdate + get config
    // await this.getUserConfig().toPromise();
    this.cd.detectChanges();
    const elId = document.getElementById("signImageConfig");
    if (!elId) {
      return;
    }
    let newFile: string = "";
    let blob = null;
    if (this.indexSelect == 0) {
      try {
        // cert đã cấu hình (type 0) -> gen theo defaultSignConfig của chứng thư, chưa cấu hình (null) -> trả về user-config
        this.applyCertDefaultSignConfig();
        let imageSize = this.setSizeFrameImage();
        blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
      } catch (e) {
        console.log("call api error, use html to image", e);
        try {
          let imageSize = this.setSizeFrameImage();
          blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
        } catch (e) {
          console.log("call api error, use html to image", e);
        }
      }

      if (!blob) {
        this.toastr.error(this.message.getMessage('messages.error_proccessing'));
        return;
      }

      const imageBase64 = await this.commonService.getBase64(blob) as string;
      newFile = imageBase64.replace(/^data:image\/[a-z]+;base64,/, "") || null;
      this.signDocumentService.postUserConfigAsync(this.signConfig).subscribe();
    } else if (this.activeImageSource === 'upload' && this.fileUploadUpload) {
      const imageBase64 = await this.commonService.getBase64(this.fileUploadUpload) as string;
      newFile = imageBase64.replace(/^data:image\/[a-z]+;base64,/, "") || null;
    } else if (this.activeImageSource === 'draw' && this.fileUploadDraw) {
      const imageBase64 = await this.commonService.getBase64(this.fileUploadDraw) as string;
      newFile = imageBase64.replace(/^data:image\/[a-z]+;base64,/, "") || null;
    }

    setTimeout(() => {
      if (this.signType === SignDocumentComponent.SIGN_SINGLE) {
        if (this.dataSignSingle !== null && this.dataSignSingle.signAll == undefined) {
          this.sign.contractId = this.dataSignSingle;
          this.certificate = this.selectedCert;
          this.sign.digitalCertificateId = this.certificate.id;
          this.sign.digitalCertificateDetailId = this.certificate.idDetail;
          this.sign.image = newFile;
          // Sign with signatures server 0
          if (this.certificate.typeCertificate === SignDocumentComponent.SIGN_SERVER) {
            // if (!this.selectedCert.imagePath) {
              this.documentService.systemSignImage.next(newFile)
            // } else {
            //   this.documentService.systemSignImage.next(null)
            // }
            //check hsm permission
            this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
              if (res.data.enableHsm) {
                this.processSignServer();
              } else {
                this.toastr.error(this.message.getMessage('messages.not_hsm_permission'))
              }
            })
          }

          // Sign with Usb Token
          if (this.certificate.typeCertificate === SignDocumentComponent.SIGN_USB_TOKEN) {
            this.blockUI.start('');
            initPlugin(this);
          }

          // Sign with SIM CA
          if (this.certificate.typeCertificate === SignDocumentComponent.SIGN_SIM_CA) {
            this.processSignSimCA();
          }

          // Sign with OTP
          if (this.certificate.typeCertificate === SignDocumentComponent.SIGN_OTP) {
            this.processSignOTP();
          }

          // Sign with HSM
          if (this.certificate.typeCertificate === SignDocumentComponent.SIGN_HSM) {
            this.processSignHSM();
          }
        } else {
          this.dialogRef.close();
          // console.log("this.dataSignSingle", this.dataSignSingle);
          this.dialog.open(SignProgressComponent, {
            width: '80%',
            data: this.dataSignSingle
          });
        }
      } else if (this.signType === SignDocumentComponent.SIGN_SLOT) {
        // if (!this.selectedCert.imagePath) {
          this.documentService.systemSignImage.next(newFile)
        // } else {
        //   this.documentService.systemSignImage.next(null)
        // }
        if (this.selectedCert.typeCertificate === SignDocumentComponent.SIGN_SERVER) {
          //check hsm permission
          this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
            if (res.data.enableHsm) {
              this.actions.next(SignDocumentComponent.CONFIRM_ACTION);
            } else {
              this.toastr.error(this.message.getMessage('messages.not_hsm_permission'))
            }
          })
        } else {
          // if (!this.selectedCert.imagePath) {
            this.documentService.systemSignImage.next(newFile)
          // } else {
          //   this.documentService.systemSignImage.next(null)
          // }
          this.actions.next(SignDocumentComponent.CONFIRM_ACTION);
        }
      }
    }, 400);
  }

  /**
   * Open dialog confirm code for sign OTP
   */
  processSignOTP() {
    this.signDocumentService.generateTransaction(this.sign.contractId, this.selectedCert.phoneNumber, null).subscribe(rs => {
      this.openDialogConfirmSignOTP(rs.data);
    });
    // if (!this.data.documentEntity.submitedToA && this.data.documentEntity.status === 1
    //   // tslint:disable-next-line:max-line-length
    //   || (!this.data.documentEntity.submitedToB && (this.data.documentEntity.status === 4 || this.data.documentEntity.status === 8) && Number(this.userType) !== 5)) {
    //   this.signDocumentService.generateTransactionDirectly(this.sign.contractId, this.selectedCert.phoneNumber).subscribe(rs => {
    //     this.openDialogConfirmSignOTP(rs.data);
    //   });
    // } else {
    //   this.signDocumentService.generateTransaction(this.sign.contractId, this.selectedCert.phoneNumber).subscribe(rs => {
    //     this.openDialogConfirmSignOTP(rs.data);
    //   });
    // }
  }

  /**
   * Open dialog confirm code for sign OTP
   */
  openDialogConfirmSignOTP(transactionId: string) {
    const dialogRef = this.dialog.open(ConfirmSignOtpComponent, {
      width: '40%',
      data: {
        documentId: this.sign.contractId,
        transaction: transactionId,
        selectedPhone: this.selectedCert.phoneNumber
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (dialogRef.componentInstance.success) {
        this.toastr.success(this.message.getMessage('messages.sign_success'));
        this.success = true;
        this.dialogRef.close();
      }
    });
  }

  getConfigKeyList(): string[] {
    return Object.keys(this.signConfig);
  }

  getUserConfig() {
    return this.signDocumentService.getUserConfigAsync()
      .pipe(tap(res => {
          if (res.success && res.data) {
            for (const key in this.signConfig) {
              this.signConfig[key].enabled = res.data[key] || false;
            }

            this.signConfig.address.value = res.data['addressDetail'] || '';
            this.signConfig.position.value = res.data['positionDetail'] || '';
            this.signConfig.confirmBy.value = res.data['signature'] || '';
            this.signConfig.fontFamily.value = res.data['fontFamily'] || '';
            this.signConfig.fontWeight.value = res.data['fontWeight'] || '';
            this.signConfig.fontStyle.value = res.data['fontStyle'] || '';
            this.signConfig.signatureImageBase64.value = res.data['signatureImageBase64'] || '';
            this.signConfig.signatureImageName.value = res.data['signatureImageName'] || '';
            this.signConfig.signaturePosition.value = res.data['signaturePosition'] || '';
            this.signConfig.signatureRatio.value = res.data['signatureRatio'] || '';

            this.signConfig.fontFamily.enabled = false;
            this.signConfig.fontWeight.enabled = false;
            this.signConfig.fontStyle.enabled = false;
            this.signConfig.signatureImageBase64.enabled = false;
            this.signConfig.signatureImageName.enabled = false;
            this.signConfig.signaturePosition.enabled = false;
            this.signConfig.signatureRatio.enabled = false;
            this.signConfig.contentPosition.value =
              res.data["contentPosition"] === "false"
                ? ContentPosition.left
                : res.data["contentPosition"];
            this.signConfig.contentPosition.enabled = false;
          }
        }),
        switchMap(() => {
          return this.signDocumentService.getDateAsync()
        })
      ).pipe(
        tap(res => {
          if (res.success) {
            this.signConfig.signingTime.value = res.data.date;
            // NOTE: Không gọi convertHtmlToImage() ở đây nữa để tránh race condition.
            // Ảnh mặc định sẽ được gen khi user thực sự bấm ký ở Tab 0.
            this.cd.detectChanges();
            setTimeout(() => {
              this.signDocumentService.setFontSize(imageConfigViewScaleId);
              this.signDocumentService.setFontSize(imageConfigRenderId);
            }, 100);
          }
        })
      )
  }

  showConfig(key: string): boolean {
    if (key === 'greenTick') {
      return false
    }

    // các value-carrier chỉ dùng làm dữ liệu/style (ảnh nhúng base64 render riêng bằng <img>,
    // font/position là style) — không bao giờ là dòng text; không chặn thì ảnh nhúng của
    // cert type 0 sẽ bị in nguyên chuỗi base64 ra preview (giống fix sign-flow-document-v2)
    if (
      key === 'signatureImageBase64' ||
      key === 'signatureImageName' ||
      key === 'signaturePosition' ||
      key === 'signatureRatio' ||
      key === 'fontFamily' ||
      key === 'fontStyle' ||
      key === 'fontWeight' ||
      key === 'contentPosition'
    ) {
      return false;
    }

    if (this.selectedCert.typeCertificate !== 3) {
      if (key === 'phoneNumber') {
        this.signConfig.phoneNumber.enabled = false;
        return false;
      }
      if (key === 'confirmBy') {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
    } else {

      if (key === 'confirmBy' && this.scopeType !== 2) {
        this.signConfig.confirmBy.enabled = true;
        return true;
      } else if (key === 'confirmBy' && this.scopeType === 2) {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
    }

    return this.signConfig[key].enabled;
  }

  setIssueTo(cert) {
    this.signConfig.enterpriseName.value = cert.issuedTo;
  }
  setEmailTo(cert) {
    this.signConfig.email.value = cert.email;
  }

  onSelectDrawSign() {
    this.canvasService.setIsSelectSignDraw(true);
  }

  setFontSize(id: string) {
    const listElement: any = document.getElementsByClassName(id);
    // console.log(listElement);
    for (const el of listElement) {
      this.setSizetext(id, el);
    }
  }

  setSizetext(id: string, el: any) {
    if (!el) {
      return;
    }
    el.style.wordBreak = 'break-word';
    if (id === imageConfigViewScaleId) {
      if (el && el.lastElementChild && el.lastElementChild.lastElementChild)
        el = el.lastElementChild.lastElementChild as HTMLElement;
    }

    if (el) {
      let fontSize = 56;
      let minSize = 32;
      let padding = 40;
      if (id === imageConfigFormPreviewId) {
        fontSize /= 4;
        minSize /= 4;
        padding /= 4;
      }

      // console.log(el);
      el.style.fontSize = fontSize + 'px';

      let parent;
      if (this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom') {
        parent = el.parentElement;
      } else {
        parent = el.parentElement.parentElement;
      }
      const parentHeight = parent.offsetHeight;
      let height = el.offsetHeight;

      while (height > parentHeight - padding && fontSize > minSize) {
        if (id === imageConfigFormPreviewId) {
          fontSize -= 1 / 4;
        } else {
          fontSize--;
        }
        el.style.fontSize = fontSize + 'px';
        height = el.offsetHeight;
      }
    }
  }

  nzSelectChange(index = 0) {
    let isShowDefaultTab = this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.selectedCert.imageUrl;
    const indexSystemTab = 0;
    const indexUploadTab = 1;
    const indexDrawTab = 2;
    this.indexSelect = index;
    if (this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT) {
      if (index === indexDrawTab) {
        this.activeImageSource = 'draw';
        this.isSelectDrawImage = true;
        this.isRenderImage = false;
        this.canvasService.setIsDisableBtnDeleteCanvas(true);
        this.systemImageSign = false;
        this.canvasService.canvasImage.subscribe((imgUpload) => {
          this.fileUpload = imgUpload;
          this.fileUploadDraw = imgUpload;
        });
        this.canvasService.setCanvasSignatureImageUrl(this.signatureImageDraw);
      }
      if (index === indexUploadTab) {
        this.activeImageSource = 'upload';
        this.isSelectDrawImage = false;
        this.isRenderImage = false;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.systemImageSign = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        if (this.selectedCert.imageUrl) {
          fetch(this.selectedCert.imageUrl)
            .then((r) => r.blob())
            .then((blobFile) => {
              const file = new File([blobFile], "fileNameGoesHere", {
                type: "image/png",
              });
              this.fileUpload = file;
              this.fileUploadUpload = file;
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
        }
      }
      if (index === indexSystemTab) {
        this.activeImageSource = 'default';
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isRenderImage = false;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.imageUrlPreview = '';
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }
    } else {
      if (index === indexUploadTab) {
        this.activeImageSource = 'upload';
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.canvasService.setIsDisableBtnDeleteCanvas(true);
      }

      if (index === indexSystemTab) {
        this.activeImageSource = 'default';
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isRenderImage = false;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.imageUrlPreview = '';
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }
    }
  }

  // trạng thái signConfig theo user-config — chụp trước khi áp config cert đầu tiên,
  // dùng để khôi phục khi ký cert chưa cấu hình (defaultSignImageType null)
  pristineSignConfig: SignatureConfig = null;

  /**
   * cert có defaultSignImageType = 0 -> áp defaultSignConfig của chứng thư lên signConfig;
   * chưa cấu hình (null) -> trả signConfig về bản user-config, bỏ nhiễm config của cert
   * trước đó (service applyCertDefaultSignConfig chỉ ghi đè in-place, không có nhánh
   * khôi phục nên cert chưa cấu hình kế tiếp vẫn giữ config của cert cũ)
   */
  applyCertDefaultSignConfig() {
    const defaultType = this.selectedCert ? this.selectedCert.defaultSignImageType : null;
    const issueTo = this.selectedCert
      ? (this.selectedCert.issuedTo || this.selectedCert.certificateName)
      : null;
    if (defaultType === 0 && this.selectedCert.defaultSignConfig) {
      if (!this.pristineSignConfig) {
        this.pristineSignConfig = JSON.parse(JSON.stringify(this.signConfig));
      }
      try {
        const saved = JSON.parse(this.selectedCert.defaultSignConfig);
        for (const key in this.signConfig) {
          // phoneNumber do màn ký tự quản theo cert đang chọn, không áp từ config
          if (key === 'phoneNumber') {
            continue;
          }
          if (saved[key] && typeof saved[key] === 'object') {
            this.signConfig[key].enabled = !!saved[key].enabled;
            if (saved[key].value !== undefined && saved[key].value !== null && saved[key].value !== '') {
              this.signConfig[key].value = saved[key].value;
            }
          } else if (saved[key] !== undefined && key === 'contentPosition') {
            this.signConfig[key].value = saved[key];
          } else {
            // field KHÔNG có trong config cert = TẮT: bắt buộc ghi đè enabled=false,
            // nếu không field đang bật theo user-config (địa chỉ, chức vụ...) sẽ lọt vào ảnh
            this.signConfig[key].enabled = false;
          }
        }
      } catch (e) {
        // config hỏng -> giữ nguyên signConfig (user-config)
        return;
      }
      // tên chủ thể luôn theo chứng thư đang ký
      if (issueTo) {
        this.signConfig.enterpriseName.value = issueTo;
      }
      // ngày giờ ký luôn là thời điểm ký, không dùng giờ đã lưu trong config
      if (this.signConfig.signingTime.enabled) {
        const datePipe = new DatePipe('vi-VN');
        this.signConfig.signingTime.value = datePipe.transform(new Date(), 'HH:mm dd/MM/yyyy');
      }
    } else if (this.pristineSignConfig) {
      // cert chưa cấu hình: trả signConfig về bản user-config, bỏ nhiễm config của cert trước
      const restored = JSON.parse(JSON.stringify(this.pristineSignConfig));
      if (this.signConfig.phoneNumber) {
        // giữ item phone của cert hiện tại (caller vừa dựng theo cert đang chọn)
        restored.phoneNumber = this.signConfig.phoneNumber;
      }
      this.signConfig = restored;
      if (issueTo) {
        this.signConfig.enterpriseName.value = issueTo;
      }
    }
  }

  async convertHtmlToImage() {
    let imgUrl = "";
    let file = null;
    try {
      // cert đã cấu hình (type 0) -> gen theo defaultSignConfig của chứng thư, chưa cấu hình (null) -> trả về user-config
      this.applyCertDefaultSignConfig();
      const imageSize = this.setSizeFrameImage();
      if (
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP &&
        this.scopeType !== 2
      ) {
        this.signConfig.confirmBy.enabled = true;
      } else {
        this.signConfig.confirmBy.enabled = false;
        delete this.signConfig.phoneNumber;
      }
      const rs = await this.imageGenerateService
        .genImage(this.signConfig, imageSize)
        .toPromise();
      file = new File([rs], "signatureImage.png", { type: "image/png" });
      imgUrl = (await this.commonService.getBase64(file)) as string;
    } catch (e) {
      console.log("call api error, use html to image", e);
      // this.blockUI.start('');
      const imageFile = await htmlToImage.toBlob(
        this.domRenderImage.nativeElement
      );
      file = new File([imageFile], "signatureImage.png", { type: "image/png" });
      imgUrl = await htmlToImage.toPng(this.domRenderImage.nativeElement);
    }

    this.fileUpload = file;
    this.fileUploadDefault = file;
    this.signatureImageDefault = imgUrl;
    this.signatureFileDefault = file;

    this.setFontSize(imageConfigViewScaleId);
    this.setFontSize(imageConfigRenderId);
    setTimeout(() => {
      this.documentService.setImageSignature({
        url: imgUrl,
        fileUpload: file,
      });
    }, 100);
    if (this.fileUploadDefault) {
      this.handlePreviewFromFileUpload(this.fileUploadDefault);
    }
  }

  handlePreviewFromFileUpload(
    fileUpload: File,
    isCertificateDefault?: boolean
  ) {
    this.commonService
      .getBase64(fileUpload)
      // tslint:disable-next-line:no-shadowed-variable
      .then((imageUrlPreviewBlod) => {
        this.imageUrlPreview = imageUrlPreviewBlod;
        if (isCertificateDefault) {
          this.avatarUrl = this.imageUrlPreview;
        }
        const img = new Image();
        img.src = this.imageUrlPreview;
        img.onload = () => {
          this.widthImageRender = img.width;
          this.heightImageRender = img.height;
          if (this.indexSelect === 1) {
            this.imagePreviewWidth = img.width;
            this.imagePreviewHeight = img.height;
          }
        };
        this.documentService.setImageSignature({
          url: this.imageUrlPreview,
          fileUpload: this.fileUpload,
        });
      });
  }

  getNumber(value: any) {
    return value.split(":") || [];
  }

  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await this.commonService.getBase64(file.originFileObj!);
    }
  };

  dummyRequest = ({ file, onSuccess, onError }) => {
    this.fileUpload = file;
    this.fileUploadUpload = file;
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  handleChange(info: { file: NzUploadFile }): void {
    // this.isFormChanging = true;

    switch (info.file.status) {
      case "uploading":
        this.loading = true;
        break;
      case "done":
        // Get this url from response in real world.
        // tslint:disable-next-line:no-non-null-assertion
        this.commonService.getBase64Avatar(
          info.file!.originFileObj!,
          (imgUrl: string) => {
            this.loading = false;
            // tslint:disable-next-line:radix
            const img = new Image();
            // Set the src attribute to your URL
            img.src = imgUrl;
            this.imagePreviewWidth = img.width;
            this.imagePreviewHeight = img.height;
            // When the image is loaded, read the available properties
            this.avatarUrl = imgUrl;
            this.imageUrlPreview = imgUrl;
            this.signatureImageUpload = imgUrl;
            this.fileUploadUpload = this.fileUpload;
            this.documentService.setImageSignature({
              url: imgUrl,
              fileUpload: this.fileUpload,
            });
          }
        );
        break;
      case "error":
        this.toastr.error("Network error");
        this.loading = false;
        break;
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  async selectCertificate(certificate) {
    this.selectedCert = certificate;
    if (
      this.selectedCert &&
      (this.selectedCert.issuedTo || this.selectedCert.certificateName)
    ) {
      const issueTo =
        this.selectedCert.issuedTo || this.selectedCert.certificateName;
      this.signConfig.enterpriseName.value = issueTo;
    } else {
      this.signConfig.enterpriseName.value = this.enterpriseName;
    }
    if (this.selectedCert && this.selectedCert.phoneNumber) {
      const phoneNumber = {
        value: null,
        enabled: false,
        label: "enterprise_contract.image_signing.no_image.phone_number",
      };
      this.signConfig = {
        enterpriseName: this.signConfig.enterpriseName,
        phoneNumber: phoneNumber,
        ...this.signConfig,
      };
      this.signConfig.phoneNumber.value = this.selectedCert.phoneNumber;
    }
    // this.signConfig.email.value = this.selectedCert.email;
    this.canvasService.setCanvasSignatureImage(null);
    this.canvasService.setCanvasImage(null);

    if (this.applyDefaultSignImageTab()) {
      return;
    }
    if (this.selectedCert.imageUrl && this.selectedCert.imageUrl !== "") {
      this.indexSelect = 1;
      this.activeImageSource = 'upload';
      this.signatureFileDefault = null;
      this.drawRestoreImage = null;
      this.canvasService.setCanvasSignatureImageUrl("");
      if (this.canvasComponent) {
        this.canvasComponent.clearCanvas();
      }
      fetch(this.selectedCert.imageUrl)
        .then((r) => r.blob())
        .then((blobFile) => {
          const file = new File([blobFile], "fileNameGoesHere", {
            type: "image/png",
          });
          this.fileUpload = file;
          this.fileUploadUpload = file;
          if (this.fileUpload) {
            this.handlePreviewFromFileUpload(this.fileUpload, true);
          }
        });
    } else {
      this.indexSelect = 0;
      this.activeImageSource = 'default';
      this.systemImageSign = true;
      this.isSelectDrawImage = false;
      this.drawRestoreImage = null;
      this.canvasService.setCanvasSignatureImageUrl("");
      if (this.canvasComponent) {
        this.canvasComponent.clearCanvas();
      }
      this.convertHtmlToImage();
      this.cd.detectChanges();
      setTimeout(() => {
        this.setFontSize(imageConfigViewScaleId);
        this.setFontSize(imageConfigRenderId);
      }, 100);
    }
  }

  /**
   * PYC-85542: ưu tiên tab theo loại ảnh ký mặc định cấu hình trong Phương thức ký
   * (0 hệ thống / 1 upload / 2 vẽ); null = chưa cấu hình -> trả false, giữ logic cũ theo ảnh CTS
   */
  applyDefaultSignImageTab(): boolean {
    const defaultSignType = this.selectedCert ? this.selectedCert.defaultSignImageType : null;
    if (defaultSignType === 2 && this.selectedCert.drawSignImagePath) {
      // ảnh vẽ: tab vẽ + khôi phục ảnh đã lưu vào ô canvas
      // API trả base64 thô (không prefix) — bọc data URL, nếu không browser coi là URL tương đối -> 404
      const drawImageBase64 = this.toDataUrl(this.selectedCert.drawSignImagePath);
      this.indexSelect = 2;
      this.activeImageSource = 'draw';
      this.systemImageSign = false;
      this.isSelectDrawImage = true;
      this.isRenderImage = false;
      this.signatureFileDefault = null;
      this.drawRestoreImage = drawImageBase64;
      this.canvasService.setCanvasSignatureImageUrl(drawImageBase64);
      this.canvasService.setIsApplyDrawSignature(true);
      this.canvasService.setIsSelectSignDraw(true);
      // nạp sẵn fileUploadDraw từ ảnh đã lưu để Xác nhận hoạt động ngay, không bắt bấm Áp dụng
      const blob = this.commonService.b64toBlob(this.selectedCert.drawSignImagePath);
      this.fileUpload = new File([blob], 'fileNameGoesHere', { type: 'image/png' });
      this.fileUploadDraw = this.fileUpload;
      return true;
    }
    if (defaultSignType === 1 && this.selectedCert.imagePath) {
      this.indexSelect = 1;
      this.activeImageSource = 'upload';
      this.systemImageSign = false;
      this.isSelectDrawImage = false;
      this.isRenderImage = false;
      this.signatureFileDefault = null;
      this.drawRestoreImage = null;
      const blob = this.commonService.b64toBlob(this.selectedCert.imagePath);
      this.fileUpload = new File([blob], 'fileNameGoesHere', { type: 'image/png' });
      this.fileUploadUpload = this.fileUpload;
      if (this.fileUpload) {
        this.handlePreviewFromFileUpload(this.fileUpload, true);
      }
      return true;
    }
    this.drawRestoreImage = null;
    return false;
  }

  toDataUrl(base64: string): string {
    if (!base64) {
      return "";
    }
    return base64.indexOf("base64,") >= 0 ? base64 : "data:image/png;base64," + base64;
  }

  async signFlowDocumentWithCertificate() {
    if (
      this.selectedCert &&
      (this.selectedCert.issuedTo || this.selectedCert.certificateName)
    ) {
      const issueTo =
        this.selectedCert.issuedTo || this.selectedCert.certificateName;
      this.signConfig.enterpriseName.value = issueTo;
    } else {
      this.signConfig.enterpriseName.value = this.enterpriseName;
    }
    if (this.selectedCert && this.selectedCert.phoneNumber) {
      const phoneNumber = {
        value: null,
        enabled: false,
        label: "enterprise_contract.image_signing.no_image.phone_number",
      };
      this.signConfig = {
        enterpriseName: this.signConfig.enterpriseName,
        phoneNumber: phoneNumber,
        ...this.signConfig,
      };
      this.signConfig.phoneNumber.value = this.selectedCert.phoneNumber;
    }
    // this.signConfig.email.value = this.selectedCert.email;
    if (this.applyDefaultSignImageTab()) {
      // tab đã chọn theo cấu hình ảnh ký mặc định của cert
    } else if (this.selectedCert.imageUrl && this.selectedCert.imageUrl !== "") {
      this.indexSelect = 1;
      this.activeImageSource = 'upload';
      fetch(this.selectedCert.imageUrl)
        .then((r) => r.blob())
        .then((blobFile) => {
          const file = new File([blobFile], "fileNameGoesHere", {
            type: "image/png",
          });
          this.fileUpload = file;
          this.fileUploadUpload = file;
          if (this.fileUpload) {
            this.handlePreviewFromFileUpload(this.fileUpload, true);
          }
        });
    } else {
      this.indexSelect = 0;
      this.activeImageSource = 'default';
      this.systemImageSign = true;
      this.isSelectDrawImage = false;
      this.avatarUrl = null;
      this.convertHtmlToImage();
      this.cd.detectChanges();
      setTimeout(() => {
        this.setFontSize(imageConfigViewScaleId);
        this.setFontSize(imageConfigRenderId);
      }, 100);
    }
  }
  transformContentPositionValue = transformContentPositionValue;
}
